import { Instance, types } from 'mobx-state-tree';

const ProgramPaymentOption = types.model('ProgramPaymentOption', {
	id: types.number,
	product_id: types.number,
	merchant_id: types.maybeNull(types.number),
	type: types.optional(types.string, ''),
	provider: types.optional(types.string, ''),
	installments_count: types.optional(types.number, 0),
	installment_amount: types.optional(types.string, ''),
	total_amount: types.optional(types.string, ''),
	currency: types.optional(types.string, ''),
	interval_unit: types.optional(types.string, ''),
	interval_count: types.optional(types.number, 1),
	is_active: types.optional(types.boolean, false),
});

const ProgramPurchaseProduct = types.model('ProgramPurchaseProduct', {
	id: types.number,
	name: types.optional(types.string, ''),
	description: types.maybeNull(types.string),
	one_time_price: types.maybeNull(types.string),
	currency: types.optional(types.string, ''),
	is_published: types.optional(types.boolean, false),
	is_one_time_purchase: types.optional(types.boolean, false),
	payment_options: types.optional(types.array(ProgramPaymentOption), []),
});

export default ProgramPurchaseProduct;

export interface IProgramPaymentOptionModel extends Instance<typeof ProgramPaymentOption> {}
export interface IProgramPurchaseProductModel extends Instance<typeof ProgramPurchaseProduct> {}
